import React from 'react';
import UserView from '../UserView/UserView';

const CoachView = ({
  coach = {},
  onClickPreviousCoach,
  onClickNextCoach,
  company = {},
  userRole = '',
  isLoading = false,
  directionalArrowsActivated = false,
  availabilitiesEditable = false,
  availabilitiesDisabled = false,
  editButtonDisplay = false,
  onlyFullAvailabilities = false,
  redBorderNoAvailabilities = false,
  subtitleAvailabilities = '',
  onSelectAvailability,
}) => {
  return (
    <UserView
      user={coach}
      onClickPreviousUser={onClickPreviousCoach}
      onClickNextUser={onClickNextCoach}
      company={company}
      userRole={userRole}
      isLoading={isLoading}
      directionalArrowsActivated={directionalArrowsActivated}
      availabilitiesEditable={availabilitiesEditable}
      availabilitiesDisabled={availabilitiesDisabled}
      editButtonDisplay={editButtonDisplay}
      redBorderNoAvailabilities={redBorderNoAvailabilities}
      subtitleAvailabilities={subtitleAvailabilities}
      typeView="coach"
      onlyFullAvailabilities={onlyFullAvailabilities}
      onSelectAvailability={onSelectAvailability}
    />
  );
};

export default CoachView;
